/* Tiloli — autocomplete + aperçu de recherche (header).
   Source = recherche COMPLÈTE Shopify (/search) via Section Rendering API, PAS le predictive
   (/search/suggest). Raison : le predictive n'indexe que titre/marque/type/tags ; la recherche
   complète indexe en plus la REF (variant SKU) et l'EAN (variant barcode) — indispensable en B2B.
   Le rendu Tiloli (pills tiloli-card-mini, hooks prix) vient de la section tiloli-predictive-search. */
(function () {
  const DEBOUNCE = 220;
  const MIN = 2;

  function debounce(fn, ms) {
    let t;
    return function () {
      const args = arguments, ctx = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, ms);
    };
  }

  class TiloliSearch extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('input[type="search"]');
      this.panel = this.querySelector('[data-tlsearch-panel]');
      this.clearBtn = this.querySelector('[data-tlsearch-clear]');
      if (!this.input || !this.panel) return;

      this.section = this.dataset.section || 'tiloli-predictive-search';
      this.ac = null;
      this.idx = -1;

      this.input.setAttribute('autocomplete', 'off');
      this.input.setAttribute('aria-expanded', 'false');

      this._run = debounce(this.run.bind(this), DEBOUNCE);
      this.input.addEventListener('input', () => { this.syncClear(); this._run(); });
      this.input.addEventListener('focus', () => { if (this.items().length) this.open(); });
      this.input.addEventListener('keydown', (e) => this.onKey(e));
      if (this.clearBtn) this.clearBtn.addEventListener('click', () => this.reset());
      document.addEventListener('click', (e) => { if (!this.contains(e.target)) this.close(); });

      this.syncClear();
    }

    items() { return Array.prototype.slice.call(this.panel.querySelectorAll('[data-tlsearch-item]')); }
    syncClear() { if (this.clearBtn) this.clearBtn.hidden = !this.input.value.length; }

    reset() {
      this.input.value = '';
      this.syncClear();
      this.panel.innerHTML = '';
      this.close();
      this.input.focus();
    }

    async run() {
      const q = this.input.value.trim();
      if (q.length < MIN) { this.panel.innerHTML = ''; this.close(); return; }
      if (this.ac) this.ac.abort();
      this.ac = new AbortController();
      // recherche complète, produits uniquement, préfixes inclus (REF/marque partielles)
      const url = '/search?q=' + encodeURIComponent(q) +
        '&type=product&options[prefix]=last&section_id=' + encodeURIComponent(this.section);
      try {
        const res = await fetch(url, { headers: { Accept: 'text/html' }, signal: this.ac.signal });
        if (!res.ok) return;
        const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
        const out = doc.querySelector('[data-tlsearch-results]');
        this.panel.innerHTML = out ? out.innerHTML : '';
        this.idx = -1;
        if (this.panel.querySelector('.tlsearch')) {
          this.open();
          this.notifyPricing(); // pills (re)injectées → re-scan prix B2B
        } else {
          this.close();
        }
      } catch (_) { /* abort/réseau : noop */ }
    }

    // Les pills sont injectées en AJAX → on relance un re-scan pour que le moteur de prix "own"
    // les traite (mêmes hooks que tiloli-feed.js). Markup déjà prêt (.tl-price__net, data-product-id/variant-id).
    notifyPricing() {
      const section = this.closest('.shopify-section') || this;
      // 1) évènement standard Shopify (les sections re-initialisent dessus)
      try { document.dispatchEvent(new CustomEvent('shopify:section:load', { bubbles: true, detail: { sectionId: section.id } })); } catch (_) {}
      // 2) évènement Tiloli dédié (cible = le panneau + ses .tl-price__net)
      try {
        this.dispatchEvent(new CustomEvent('tl:cards-injected', {
          bubbles: true,
          detail: { container: this.panel, prices: this.panel.querySelectorAll('.tl-price__net') }
        }));
      } catch (_) {}
    }

    open() { this.classList.add('is-open'); this.input.setAttribute('aria-expanded', 'true'); }
    close() { this.classList.remove('is-open'); this.input.setAttribute('aria-expanded', 'false'); this.idx = -1; this.mark(); }

    mark() {
      const its = this.items();
      for (let i = 0; i < its.length; i++) {
        if (i === this.idx) its[i].setAttribute('aria-selected', 'true');
        else its[i].removeAttribute('aria-selected');
      }
    }

    setIdx(i) {
      const n = this.items().length;
      if (!n) return;
      this.idx = (i + n) % n;
      this.mark();
      const el = this.items()[this.idx];
      if (el) el.scrollIntoView({ block: 'nearest' });
    }

    onKey(e) {
      if (e.key === 'Escape') { this.close(); return; }
      const its = this.items();
      if (e.key === 'ArrowDown') { e.preventDefault(); this.open(); this.setIdx(this.idx + 1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); this.open(); this.setIdx(this.idx - 1); }
      else if (e.key === 'Enter') {
        if (this.idx >= 0 && its[this.idx]) {
          const a = its[this.idx].querySelector('a');
          if (a) { e.preventDefault(); a.click(); }
        }
        // sinon : laisse le <form> se soumettre → page /search complète
      }
    }
  }

  customElements.define('tiloli-search', TiloliSearch);
})();
